import { render, staticRenderFns } from "./CustomerPayment.vue?vue&type=template&id=72285a70&scoped=true"
import script from "./CustomerPayment.vue?vue&type=script&lang=js"
export * from "./CustomerPayment.vue?vue&type=script&lang=js"
import style0 from "./CustomerPayment.vue?vue&type=style&index=0&id=72285a70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72285a70",
  null
  
)

export default component.exports